import Vue from "vue";

class eventClass extends Vue {
	public readonly events = {
		AXIOS_RESPONSE_ERROR: "axios-response-error",
		USER_LOGIN: "user-login",
		USER_LOGOUT: "user-logout",
	};
}

const eventHub = new eventClass();
export default eventHub;
